import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  {
    title: 'Herzlich willkommen bei Ilmify!',
    body: 'Ihr Konto ist jetzt aktiv. In wenigen Schritten erklären wir Ihnen, wie Sie Ihren ersten Wettbewerb starten.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
  },
  {
    title: 'Quiz erstellen',
    body: 'Erstellen Sie Ihr erstes Quiz unter "Quiz-Verwaltung". Wählen Sie Fragen aus der Datenbank und passen Sie Schwierigkeitsgrad und Altersgruppen an.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    ),
  },
  {
    title: 'Wettbewerb starten',
    body: 'Starten Sie das Quiz — Teilnehmer konnen mit einem 4-stelligen PIN beitreten. Auf dem Bildschirm sehen Sie alle Teilnehmer in Echtzeit.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="5 3 19 12 5 21 5 3"/>
      </svg>
    ),
  },
];

export default function OnboardingWizard({ onClose }) {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const finish = () => {
    localStorage.setItem('ilmify_onboarded', '1');
    onClose();
    navigate('/admin/quizzes/new');
  };

  const dismiss = () => {
    localStorage.setItem('ilmify_onboarded', '1');
    onClose();
  };

  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: 24,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        maxWidth: 460, width: '100%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
      }}>
        {/* Step dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 28 }}>
          {STEPS.map((_, i) => (
            <div key={i} style={{
              width: i === step ? 20 : 8, height: 8, borderRadius: 4,
              background: i === step ? 'var(--primary)' : 'var(--border)',
              transition: 'all 0.3s',
            }} />
          ))}
        </div>

        <div style={{ marginBottom: 20 }}>{current.icon}</div>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: 'var(--text)' }}>
          {current.title}
        </h2>
        <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.6, marginBottom: 32 }}>
          {current.body}
        </p>

        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          {!isLast ? (
            <>
              <button className="btn btn-secondary" onClick={dismiss} style={{ fontSize: 13 }}>
                Überspringen
              </button>
              <button className="btn btn-primary" onClick={() => setStep(s => s + 1)} style={{ minWidth: 120 }}>
                Weiter
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-secondary" onClick={dismiss} style={{ fontSize: 13 }}>
                Später
              </button>
              <button className="btn btn-primary" onClick={finish} style={{ minWidth: 160 }}>
                Erstes Quiz erstellen
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
